import React, { useEffect, useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse } from "react-collapse";
import axios from "axios";
import { useSetRecoilState } from "recoil";

import { protocolType } from "../../../store/audit details/atom";
import MarsAdminTable from "./SupperAdminTable";
import "./LandingScreen.scss";
import { getToken } from "../../auth/authConfig";

const LandingScreen = () => {
  const [getLoading, setGetLoading] = useState(false);
  const [getError, setGetError] = useState(false);
  const [AuditedForm, setAuditedForm] = useState();
  const [AuditVersioning, setAuditVersioning] = useState();
  const [AuditCompleted, setAuditCompleted] = useState();
  const [AuditBackForm, setAuditBackForm] = useState([]);
  const [expanded, setExpanded] = useState([true, false, false, false]);
  const setProtocolType = useSetRecoilState(protocolType);


  const handleToggle = (index) => {
    setExpanded((prev) =>
      prev.map((value, i) => (i === index ? !value : value))
    );
  };

  useEffect(() => {
    AuditedFormList();
  }, []);


  useEffect(() => {
    setProtocolType("");
  }, []);

  const AuditedFormList = async () => {
    try {
      setGetLoading(true);
      const token = await getToken();
      const url = `${process.env.REACT_APP_SERVER_URL}/super/listV2`;

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;


        if (json.Message) {
          setAuditedForm([]);
          setGetLoading(false);
          setGetError(true);
          setTimeout(() => {
            setGetError(false);
          }, 5000);
        } else {
          const initiatedForms = json  && json.initaited_forms
          const Completed = json  && json.completed_forms;
          const sendback = json  && json.sentback_forms
          const versioning = json  && json.versioned_forms;

  
          setAuditedForm(initiatedForms || []);
          setAuditCompleted(Completed || [])
          setAuditBackForm(sendback || [])
          setAuditVersioning(versioning || [])
          setGetLoading(false);
        }
        // console.log("json data", json);
      }
    } catch (e) {
      console.log("getting error while fetching the audited list");
    }
  };

  return (
    <div id="super-admin-landing-page" className="super-admin-landing-section">
      <div className="mars-Audited-Forms-sections super-auditor-common">
        <div className="collapse-section">
          <h3 className="main-heading">List of Initiated Audited Forms</h3>
          <div className="collapse-btn" onClick={() => handleToggle(0)}>
            {expanded[0] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
        </div>

        <Collapse isOpened={expanded[0]}>
          <MarsAdminTable
            loading={getLoading}
            error={getError}
            tableData={AuditedForm || []}
            title="List of Initiated Audited Forms"
            color="orange"
            expand={expanded[0]}
            download={false}
            editable={true}
            AuditedFormList={AuditedFormList}
            colorValue="ff8200"
            buttonView = '#efc599'
            buttonText = '#915313'

          />
        </Collapse>
      </div>

      <div className="mars-AuditedVersioning-Forms-sections super-auditor-common">
        <div className="collapse-section">
          <h3 className="main-heading">List of Forms Requiring Versioning</h3>
          <div className="collapse-btn" onClick={() => handleToggle(1)}>
            {expanded[1] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
        </div>

        <Collapse isOpened={expanded[1]}>
          <MarsAdminTable
            loading={getLoading}
            error={getError}
            tableData={AuditVersioning || []}
            title="List of Forms Requiring Versioning"
            color="red"
            expand={expanded[1]}
            download={true}
            editable={true}
            AuditedFormList={AuditedFormList}
            colorValue="ff3c14"
            buttonView = '#f1c2b8'
            buttonText = '#9d3520'
            version = {1}

          />
        </Collapse>
      </div>

      <div className="mars-AuditedCompleted-Forms-sections super-auditor-common">
        <div className="collapse-section">
          <h3 className="main-heading">List of Audit Completed Forms</h3>
          <div className="collapse-btn" onClick={() => handleToggle(2)}>
            {expanded[2] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
        </div>

        <Collapse isOpened={expanded[2]}>
          <MarsAdminTable
            loading={getLoading}
            error={getError}
            // tableData={AuditCompleted || []}
            tableData={AuditCompleted || []}
            title="List of Audit Completed Forms"
            color="green"
            expand={expanded[2]}
            download={true}
            editable={false}
            AuditedFormList={AuditedFormList}
            colorValue="769711"
            buttonView = '#d8e5ad'
            buttonText = '#41530b'    

          />
        </Collapse>
      </div>

      <div className="mars-Audited-BackForms-sections super-auditor-common">
        <div className="collapse-section">
          <h3 className="main-heading">List of Sent Back Forms</h3>
          <div className="collapse-btn" onClick={() => handleToggle(3)}>
            {expanded[3] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
        </div>

        <Collapse isOpened={expanded[3]}>
          <MarsAdminTable
            loading={getLoading}
            error={getError}
            tableData={AuditBackForm || []}
            // tableData={AuditedForm || []}
            title="List of Sent Back Forms"
            color="perple"
            expand={expanded[3]}
            download={false}
            editable={true}
            AuditedFormList={AuditedFormList}
            colorValue="9600ff"
            buttonView = '#d1b1e7'
            buttonText = '#48176b'
          />
        </Collapse>
      </div>
    </div>
  );
};

export default LandingScreen;
